import {
  ActionCreatorWithoutPayload,
  ActionCreatorWithPayload,
  createAction,
} from '@reduxjs/toolkit'
import { View } from 'models/View'
import type { ViewFiltersInput } from 'apollo/generated/globalTypes'
import {
  cleanViewFilters,
  parseFiltersToMagicSearch,
} from 'store/selectors/parsedAsMagicSearch'

const PREFIX = 'APPCONFIG_'

export const VIEW_FILTERS_SAVED = `${PREFIX}VIEW_FILTERS_SAVED`

export const viewFiltersSaved = createAction(
  VIEW_FILTERS_SAVED,
  (view: View, filters: ViewFiltersInput) => ({
    payload: {
      view: { ...view, filters },
      filters: parseFiltersToMagicSearch(filters),
      previousFilterKeys: Object.keys(
        parseFiltersToMagicSearch(cleanViewFilters(view.filters)),
      ),
    },
  }),
)

export interface IConfigActions {
  /** Cleans saved state for magic search in config */
  clearViewFilters: ActionCreatorWithoutPayload<string>
  /** Sets current view */
  setCurrentView: ActionCreatorWithPayload<View>
  /** Update sentiment Rounding flag */
  setSentimentRounding: ActionCreatorWithPayload<boolean>
}

export const appConfigurationActions: IConfigActions = {
  clearViewFilters: createAction<undefined>(`${PREFIX}CLEAR_VIEW_FILTERS`),
  setCurrentView: createAction<View>(`${PREFIX}SET_CURRENT_VIEW`),
  setSentimentRounding: createAction<boolean>(
    `${PREFIX}UPDATE_SENTIMENT_ROUNDING`,
  ),
}
